import React from 'react';
import { Button, Dropdown, Tooltip } from 'antd';
import type { MenuProps } from 'antd';
import {
  SunOutlined,
  MoonOutlined,
  DesktopOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { useTheme } from '../../hooks/useTheme';

interface ThemeToggleProps {
  size?: 'small' | 'middle' | 'large';
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ size = 'middle' }) => {
  const { mode, resolvedTheme, changeTheme } = useTheme();

  const getIcon = () => {
    if (mode === 'system') {
      return <DesktopOutlined />;
    }
    return resolvedTheme === 'dark' ? <MoonOutlined /> : <SunOutlined />;
  };

  const getTooltip = () => {
    switch (mode) {
      case 'light':
        return 'Tema claro';
      case 'dark':
        return 'Tema oscuro';
      case 'system':
        return `Tema del sistema (${resolvedTheme === 'dark' ? 'oscuro' : 'claro'})`;
      default:
        return 'Cambiar tema';
    }
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'light',
      icon: <SunOutlined />,
      label: 'Claro',
      extra: mode === 'light' ? <CheckOutlined style={{ color: 'var(--color-primary)' }} /> : null,
      onClick: () => changeTheme('light'),
    },
    {
      key: 'dark',
      icon: <MoonOutlined />,
      label: 'Oscuro',
      extra: mode === 'dark' ? <CheckOutlined style={{ color: 'var(--color-primary)' }} /> : null,
      onClick: () => changeTheme('dark'),
    },
    {
      key: 'system',
      icon: <DesktopOutlined />,
      label: 'Sistema',
      extra: mode === 'system' ? <CheckOutlined style={{ color: 'var(--color-primary)' }} /> : null,
      onClick: () => changeTheme('system'),
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
    >
      <Tooltip title={getTooltip()}>
        <Button
          type="text"
          icon={getIcon()}
          size={size}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      </Tooltip>
    </Dropdown>
  );
};

export default ThemeToggle;
